<template>
  
  <div id="personal_strengths_wrapper" class="">
    
    <div class="min-vh-100 bg-turquoise py-5">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-10">
            <h2 class="h3 text-center">{{ $t(iKey('personal_strengths_section', 'personal_strengths', 'headline')) }}</h2>
            <p class="guide-text text-center my-5 px-5">{{ $t(iKey('personal_strengths_section', 'personal_strengths', 'description')) }}</p>
            </div>
          </div>
          <form>
            <p class="form-field statement" v-html="insertTextFields($t(iKey('personal_strengths_section', 'personal_strengths', 'statement')))"></p>
          </form>
          <div class="text-center"><button class="btn-reset" v-on:click="storeResponse">{{ $t(iKey('personal_strengths_section', 'personal_strengths', 'submit')) }}</button></div>
        </div>
    </div>
  </div>

</template>

<script>
import { TweenLite } from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'
ScrollToPlugin; // needed so ScrollToPlugin gets regsitered w webpack.

export default {
  name: 'PersonalStrengths',
  props: [
    'personal_strengths_section',
    'profiles'
  ],
  methods: {
    insertTextFields(string){
      let np = this.$t(this.iKey('personal_strengths_section', 'personal_strengths', 'name_placeholder'))
      let sp = this.$t(this.iKey('personal_strengths_section', 'personal_strengths', 'strength_placeholder'))
      let cp = this.$t(this.iKey('personal_strengths_section', 'personal_strengths', 'cause_placeholder'))
      const name_field = '<input type="text" id="u_name" placeholder=" ' + np + '">';
      const strength_field = '<input type="text" id="u_strength" placeholder=" ' + sp + '">';
      const cause_field = '<input type="text" id="u_cause" placeholder=" ' + cp + '">';
      var newString = ""
      
      newString = string.replace('{{name}}', name_field)
      newString = newString.replace('{{strength}}', strength_field)
      newString = newString.replace('{{cause}}', cause_field)
      return newString
    },
    storeResponse(){
      var uname = document.getElementById('u_name').value
      var ustrength = document.getElementById('u_strength').value
      var ucause = document.getElementById('u_cause').value
      this.$store.dispatch('page/POPULATE_USER_NAME', uname)
      this.$store.dispatch('page/POPULATE_USER_STRENGTH', ustrength)
      this.$store.dispatch('page/POPULATE_USER_CAUSE', ucause)

      TweenLite.to(window, 1, {scrollTo: '#tell', onComplete: () => {
        document.getElementById('tell_header').focus();
      }})

    }
  },
  mounted(){
    // var dur = this.windowHeight
    // const scene = this.$scrollmagic.scene({
    //     triggerElement: '#personal_strengths_wrapper',
    //     triggerHook: 0,
    //     duration: dur
    // })
    // this.$scrollmagic.addScene(
    //   scene
    //       .setPin('#personal_strengths_wrapper')
    //       //.addIndicators({name: 'Scene 3'})
    // )  
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#personal_strengths {
  overflow-x: hidden;
}
#personal_strengths_wrapper {
  
}
.bg-turquoise {
  background-image: url(../../assets/images/security-envelope-pattern.jpg);
  background-size: cover;
}
.statement {
  line-height: 65px;
}
.guide-text {
  transform: rotate(-1deg);
}
button {
  border: 2px solid #382e2b;
  width: 120px;
  height: 50px;
  font-weight: bold;
}
</style>

<style>
#personal_strengths_wrapper input {
  border: 0px;
  height: 50px;
}
</style>
